import { Carousel } from './Carousel';
import { C } from './SiteChrome';
import { imageSrc } from '../lib/blogApi';

/**
 * The carousel slides made for LinkedIn and Instagram, shown whole, three across
 * (one on a phone) and each filling its share of the width, in a swipeable block
 * inside a post. Width and height are stored with each slide so
 * the space is held before the picture arrives; only the first loads at once,
 * the rest as the reader gets to them.
 *
 * `single` shows one slide at a time, moving on by itself, for a narrow column
 * (the challenge page sets it beside its text).
 */
const PostSlides = ({ slides, onOpen, single = false, style }) => (
    <figure style={{ margin: '36px 0', ...style }}>
        <Carousel label="Slide" row={!single} single={single} intervalMs={single ? 5000 : 0} autoscroll={single ? 0 : 25}>
            {slides.map((slide, i) => (
                <img
                    key={slide.src}
                    src={imageSrc(slide.src)}
                    alt={slide.alt || ''}
                    width={slide.w || undefined}
                    height={slide.h || undefined}
                    loading={i === 0 ? 'eager' : 'lazy'}
                    onClick={() => onOpen && onOpen(i)}
                    style={{ display: 'block', width: '100%', height: 'auto', borderRadius: 18, background: C.faqBg, cursor: onOpen ? 'zoom-in' : undefined }}
                />
            ))}
        </Carousel>
    </figure>
);

export default PostSlides;
